import React, { FC, useEffect, useState } from 'react';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { useSelector } from 'react-redux';
import getSelectedBundleProducts from 'store/publicAssetProduct/selector/getSelectedBundleProducts';
import ReactPlaceholder from 'react-placeholder';
import getLoadingProducts from 'store/publicAssetProduct/selector/getLoadingProducts';
import BundledProductsGroup from '../StudioBundledProductsGroup/StudioBundledProductsGroup';
import styles from './StudioBundleProducts.module.scss';

export interface StudioBundleProductsProps {
  abstractProduct?: AppBundle.Api.Entity.App.V1.IAbstractProduct;
  productId: number;
}

export const getBundleGroups = (productId: number, abstractProduct?: AppBundle.Api.Entity.App.V1.IAbstractProduct) => {
  if (abstractProduct && productId) {
    const targetProduct = abstractProduct?.products?.find((productItem) => productItem.productId === productId);
    return targetProduct ? targetProduct.bundleGroups || [] : [];
  }
  return undefined;
};

const StudioBundleProducts: FC<StudioBundleProductsProps> = ({ abstractProduct, productId }) => {
  const bundleGroups = getBundleGroups(productId, abstractProduct) || [];
  const [, setPreventFromProceedNext] = useState<boolean>();
  const selectedBundleProducts = useSelector(getSelectedBundleProducts);
  const loadingProducts = useSelector(getLoadingProducts);

  useEffect(() => {
    // check if bundle group requires selection are met the selected products
    let prevent = false;
    bundleGroups.forEach((group) => {
      if (group.canBeNotSelected === false) {
        const selectedBundleProduct = selectedBundleProducts?.find(
          (bundledProduct) => bundledProduct.bundleGroupId === group.bundleGroupId && bundledProduct.productId > 0,
        );
        if (!selectedBundleProduct) {
          prevent = true;
        }
      }
    });
    setPreventFromProceedNext(prevent);
  }, [bundleGroups, selectedBundleProducts]);

  if (loadingProducts) {
    return (
      <>
        <ReactPlaceholder
          type="rect"
          ready={false}
          showLoadingAnimation
          style={{ width: '100%', height: '22px', marginBottom: '16px' }}
        >
          <div />
        </ReactPlaceholder>
        <div className={styles.products}>
          {Array.from({ length: 8 }, (v, i) => {
            return (
              <ReactPlaceholder
                key={`ph${i}`}
                type="rect"
                ready={false}
                showLoadingAnimation
                style={{ width: '51px', height: '51px', marginRight: '4px' }}
              >
                <div />
              </ReactPlaceholder>
            );
          })}
        </div>
      </>
    );
  }

  return (
    <div className={styles.bundleProducts}>
      {bundleGroups.map((bundleGroup) => (
        <BundledProductsGroup
          key={`bg${bundleGroup.bundleGroupId}`}
          bundleGroup={bundleGroup}
          allSelectedProducts={selectedBundleProducts}
        />
      ))}
    </div>
  );
};

export default StudioBundleProducts;
